import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';
import type { CatalogItem } from '../api/catalogApi';

export function ServiceForm({ item, onClose }: { item?: CatalogItem; onClose: () => void; onDone: (message: string) => void }) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={item ? t('Chỉnh sửa dịch vụ') : t('Thêm dịch vụ')} onClose={onClose} />;
}
